module.exports = __webpack_public_path__ + "static/img/u810b.ff8606a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/u810b.jpg
// module id = pPeb
// module chunks = 73